<template>
    <div class="order-record-tab">
        <!-- 下样记录 -->
        <table class="record-table">
            <thead>
                <tr>
                    <th>序号</th>
                    <th>订单号</th>
                    <th>样衣颜色尺码</th>
                    <th>总数量</th>
                    <th>订单日期</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in recordList" :key="index">
                    <td>{{ item.order }}</td>
                    <td>{{ item.order_id }}</td>
                    <td>{{ item.specs }}</td>
                    <td>{{ item.quantity }}</td>
                    <td>{{ item.create_time | date_format }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { getOrderRecord } from '@/api/index';
export default {
    name: 'OrderRecordTab',
    computed: {
        uuid() {
            return this.$route.query.uuid;
        }
    },
    data() {
        return {
            recordList: []
        };
    },
    mounted() {
        this.getOrderRecordList();
    },
    methods: {
        getOrderRecordList() {
            getOrderRecord({ uuid: this.uuid }).then(res => {
                if(res.code == 0) {
                    this.recordList = (res.data || []).map((item, index) => {
                        const specs = this.getSpecs(item.quantity_detail);
                        return {
                            ...item,
                            order: index + 1,
                            specs,
                        }
                    });
                }
            });
        },
        getSpecs(obj) {
            let result = [];
            Object.entries(obj).forEach(([sizeKey, colorMap]) => {
                Object.entries(colorMap).forEach(([colorIdKey, detail]) => {
                    const combinedKey = `${sizeKey} ${detail.color_name}`
                    result.push(combinedKey);
                })
            })
            return result.join(',');
        }
    },
};
</script>

<style lang="scss" scoped>
.order-record-tab {

    .record-table {
        width: 100%;
        border-collapse: separate;
        border-spacing: 0;
        font-size: 14px;
        border-radius: 10px 10px 0 0;
        border: 1px solid #e3e3e3;


        th {
            background: #F8F9FB;
            color: #666666;
            border-top: 1px solid #e3e3e3;
            // border-bottom: 1px solid #e3e3e3;
            padding: 14px 16px;
            text-align: left;
        }

        td {
            color: #333333;
            border-top: 1px solid #e3e3e3;
            // border-bottom: 1px solid #e3e3e3;
            padding: 24px 16px;
            text-align: left;
        }
        thead {
            tr:first-child {
                th {
                    border-top: none;
                }
            }
            th:first-child{
                border-radius: 10px 0 0 0;
            }
            th:last-child{
                border-radius: 0 10px 00;
            }
        }
    }
}
</style>